import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: "eu-west-2_WFA6wtB7v",
      userPoolClientId: "5n29ejmj3huee0n7rpsr0efgm0",
    },
  },
});
